import { pmt } from '@/pages/blueprint-lite/utils/finance';

import type { CalculationSettings } from '../config/calculationSettings';
import type { ExistingProperty, PropertyUse, RepaymentsBreakdown } from '../types';

export interface RepaymentsInput {
  loanAmount: number;
  purchasePrice: number;
  rentalYieldPct: number;
  propertyUse: PropertyUse;
  hasPurchase: boolean;
  existingProperties: ExistingProperty[];
  settings: CalculationSettings;
}

export function computeRepayments(input: RepaymentsInput): RepaymentsBreakdown {
  const indicativeMonthly =
    input.loanAmount > 0
      ? pmt(
          input.loanAmount,
          input.settings.indicativeRate,
          input.settings.loanTermMonths,
        )
      : 0;

  const purchaseRentMo =
    input.propertyUse === 'investment' && input.hasPurchase
      ? (input.purchasePrice * (input.rentalYieldPct / 100)) / 12
      : 0;

  const existingRentMo = input.existingProperties.reduce(
    (sum, p) => sum + p.monthlyRent,
    0,
  );

  const rentalMonthly = purchaseRentMo + existingRentMo;

  return { indicativeMonthly, rentalMonthly };
}
